module.exports = __webpack_public_path__ + "img/9788952780300.98fc58ee.jpg";